// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { GroundingsRoutingModule } from './groundings-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { GroundingsListComponent } from 'src/app/modules/groundings/pages/groundings-list/groundings-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    GroundingsRoutingModule,
    // PublicModule,
  ],
  declarations: [
    GroundingsListComponent,
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class GroundingsModule { }
